import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import {
  UPDATE_EMPLOYEE_LICENSES_IS_PING_FLAG
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";

import { Home as HomeIcon, Notifications as NotificationsIcon } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import BuilderIcon from "../../assets/images/marker_yellow.png";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChatIcon from "@mui/icons-material/Chat";
import PushPinIcon from "@mui/icons-material/PushPin";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SupportIcon from "@mui/icons-material/Support";
import VideocamIcon from "@mui/icons-material/Videocam";

import AdsClickIcon from "@mui/icons-material/AdsClick";
import CalculateIcon from "@mui/icons-material/Calculate";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FolderIcon from "@mui/icons-material/Folder";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import PhotoIcon from "@mui/icons-material/Photo";
import PsychologyIcon from "@mui/icons-material/Psychology";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";

import { Pending } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setLicences } from "../../redux/actions/actions";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../utils/clientEmployeeAppsLicenses";

function EditOptions({ open, handleClose }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const [appLicence, setAppLicence] = useState([]);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [loadingId, setLoadingId] = useState(-1);

  const LANGUAGE = ClientEnglishFallback.ClientHomeEditModal(
    multiLanguageData?.ClientHomeEditModal || {}
  );

  const { TEXT_PIN_APPLICATIONS } = LANGUAGE;

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    await getAppLicence();
  };
  const getAppLicence = async () => {
    try {
      let appLicenceResponse = await fetchClientEmployeeAppsLicensesDetails(
        selectedClientData?.ClientId,
        selectedClientData?.ClientEmployeeId,
        loginData?.accessToken
      );
      if (appLicenceResponse?.status === 200) {
        const normalizedResponse = normalizeClientEmployeeAppsLicensesResponse(appLicenceResponse);
        const appLicenceData = normalizedResponse?.data?.data;
        const notPictureboard = appLicenceData?.filter(
          (licence) => licence.AppName !== "Picture Board"
        );
        const sortedAppLicenceData = notPictureboard?.sort((a, b) => {
          return b.IsPin - a.IsPin;
        });

        setAppLicence(sortedAppLicenceData);
        let mergedData = [
          {
            AppName: "Home"
          },
          ...sortedAppLicenceData,
          {
            AppName: "BuildID",
            route: "/dashboard"
          }
        ];
        dispatch(
          setLicences({
            ...normalizedResponse,
            data: {
              ...normalizedResponse.data,
              data: mergedData,
              apps: mergedData
            }
          })
        );
        setLoadingId(0);
      } else {
        console.log("getAppLicence-> Error Getting App Licence");
      }
    } catch (error) {
      console.log("getAppLicence-> Error Getting App Licence: ", error);
    }
  };
  const updatePin = async (ClientId, EmployeeId, AppId, licenseTypeId, flag) => {
    setLoadingId(AppId);

    const obj = {
      Id: 0,
      ClientId: ClientId,
      EmployeeId: EmployeeId,
      AppId: AppId,
      IsPin: !flag,
      ModifiedBy: loginData?.userInformation?.UserId
    };
    try {
      const updateResponse = await Postrequestcall(
        UPDATE_EMPLOYEE_LICENSES_IS_PING_FLAG,
        obj,
        loginData?.accessToken
      );
      if (updateResponse?.status === 201) {
        const index = appLicence.findIndex((licence) => licence.ClientId === ClientId);

        if (index !== -1) {
          appLicence[index].IsPin = !appLicence[index].IsPin;

          setAppLicence([...appLicence]);
        }
        setShouldUpdate(true);
        getAppLicence();
      } else {
        console.log("updatePin-> Error When Updating Employee Licences Pin");
      }
    } catch (error) {
      setLoadingId(0);
      console.log("updatePin-> Error When Updating Employee Licences Pin: ", error);
    }
    setLoadingId(0);
  };

  const whichIcon = (iconName, clientColor) => {
    switch (iconName) {
      case "Home":
        return <HomeIcon sx={{ color: clientColor }} />;
      case "Safety Incidents":
        return <HealthAndSafetyIcon sx={{ color: clientColor }} />;
      case "Support Requests":
        return <SupportAgentIcon sx={{ color: clientColor }} />;
      case "Safety Observations":
        return <SupportIcon sx={{ color: clientColor }} />;
      case "Expenses":
        return <RequestQuoteIcon className="menu-icons" sx={{ color: clientColor }} />;
      case "Change Tracker":
        return <TrackChangesIcon sx={{ color: clientColor }} />;
      case "Site Activity Reports":
        return <QueryStatsIcon sx={{ color: clientColor }} />;
      case "Coaching":
        return <PsychologyIcon sx={{ color: clientColor }} />;
      case "Site Estimates":
        return <CalculateIcon sx={{ color: clientColor }} />;
      case "Communicator":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Timesheets":
        return <CalendarMonthIcon sx={{ color: clientColor }} />;
      case "Actions":
        return <AdsClickIcon sx={{ color: clientColor }} />;
      case "Chat":
        return <ChatIcon sx={{ color: clientColor }} />;
      case "Take5":
        return <SettingsVoiceIcon sx={{ color: clientColor }} />;
      case "Site Filing":
        return <FolderIcon sx={{ color: clientColor }} />;
      case "Quality Control":
        return <FactCheckIcon sx={{ color: clientColor }} />;
      case "Notifications":
        return <NotificationsIcon sx={{ color: clientColor }} />;
      case "BuildID":
        return <img loading="lazy" src={BuilderIcon} height={25} width={20} />;

      case "Videos":
        return <VideocamIcon sx={{ color: clientColor }} />;
      case "picture-board":
        return <PhotoIcon sx={{ color: clientColor }} />;

      case "Inspections":
        return <SavedSearchIcon sx={{ color: clientColor }} />;
      case "Fixed Assets":
        return <ShoppingBagIcon sx={{ color: clientColor }} />;
      default:
        return <Pending sx={{ color: clientColor }} />;
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose(shouldUpdate)}
      aria-labelledby="modal-add-client-support"
      aria-describedby="modal-add-client">
      {loadingId === -1 ? (
        <Loader fullScreen />
      ) : (
        <Box className="client-modal-responsive">
          <Grid container spacing={1}>
            <Grid size={12}>
              <IconButton
                sx={{
                  display: "flex",
                  justifySelf: "flex-end",
                  color:
                    selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                      ? selectedClientData?.AccentColor
                      : BILightGrey
                }}
                onClick={() => handleClose(shouldUpdate)}>
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid size={12}>
              <Typography variant="body1" color="initial">
                {TEXT_PIN_APPLICATIONS}
              </Typography>
            </Grid>
          </Grid>
          <Stack
            sx={{
              maxHeight: "70vh",
              overflowY: "auto"
            }}>
            <List>
              {appLicence
                ?.filter((licence) => licence.AppName !== "Chat")
                .map((licence, index) => (
                  <ListItem
                    className="pagelist-content"
                    key={index}
                    secondaryAction={
                      <Box display={"flex"} columnGap={2}>
                        {loadingId === licence.AppId ? (
                          <IconButton edge="end" aria-label="loader" disabled={true} size="small">
                            <CircularProgress
                              sx={{ color: selectedClientData?.AccentColor }}
                              size="20px"
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            edge="end"
                            aria-label="pin icon"
                            onClick={() =>
                              updatePin(
                                licence?.ClientId,
                                licence?.EmployeeId,
                                licence?.AppId,
                                licence?.LicenseTypeId,
                                licence?.IsPin
                              )
                            }>
                            <PushPinIcon
                              sx={{
                                color: licence.IsPin === true ? selectedClientData?.AccentColor : ""
                              }}
                            />
                          </IconButton>
                        )}
                      </Box>
                    }
                    disablePadding>
                    <ListItemButton
                      onClick={() =>
                        updatePin(
                          licence?.ClientId,
                          licence?.EmployeeId,
                          licence?.AppId,
                          licence?.LicenseTypeId,
                          licence?.IsPin
                        )
                      }
                      role={undefined}
                      dense>
                      <ListItemIcon>
                        {whichIcon(licence.AppName, selectedClientData?.AccentColor)}
                      </ListItemIcon>
                      <ListItemText id={licence.id} primary={licence.AppName} />
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
          </Stack>
        </Box>
      )}
    </Modal>
  );
}

export default EditOptions;
